/**
 * New Latitude Movers
 * @author Leap Logic
 */

import 'es6-shim';
import './bootstrap';
import seo from './classes/SEO';
import googleAutocomplete from './widgets/GoogleAutocomplete';

let app = new Vue({
  el: '.app',

  data: {},

  mounted() {

    let welcomeHide = document.querySelector('.welcome-banner .dark');
    console.log(welcomeHide);
    if (welcomeHide) {
        welcomeHide.addEventListener('click', function(e) {
            let welcome = document.querySelector('.welcome-banner');
            welcome.classList.add('hide');
            e.preventDefault();
        });
    }
    seo.trackEvents();
    

  },

  methods: {}
});
